import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';

export default class DashboardListViewServices extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  public async getDashboardTemplates(): Promise<any> {
    return super.get(api.get_dashboard_templates);
  }

  public async createDashboardTemplate(data: dynamicObj): Promise<any> {
    return super.post(api.create_dashboard, data);
  }

  public async deleteDashboardTemplate(data: FormData): Promise<any> {
    return super.delete(api.delete_dashboard, data);
  }

  public async editDashboardTemplate(data: FormData): Promise<any> {
    return super.put(api.update_dashboard, data);
  }
}
